const LOCAL_API_BASE_URL = "/api";
const PRODUCTION_API_BASE_URL = "https://maintenanceshift.co.za/api";
const LOCAL_LOGISTICS_API_BASE_URL = "/api";
const PRODUCTION_LOGISTICS_API_BASE_URL = "https://maintenanceshift.co.za/api";

const isLocalHost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalHost ? LOCAL_API_BASE_URL : PRODUCTION_API_BASE_URL);

export const LOGISTICS_API_BASE_URL =
  process.env.REACT_APP_LOGISTICS_API_URL ||
  (isLocalHost
    ? LOCAL_LOGISTICS_API_BASE_URL
    : PRODUCTION_LOGISTICS_API_BASE_URL);

export const API_BASE_URL_WITH_SLASH = `${API_BASE_URL.replace(/\/$/, "")}/`;

// The Diagnostics Knowledge Service (maintenanceshift-knowledge-api). In production it sits behind the same
// host as Django, routed by path (/api/knowledge*) at the load balancer.
const LOCAL_KNOWLEDGE_API_BASE_URL = "/api/knowledge";
const PRODUCTION_KNOWLEDGE_API_BASE_URL = "https://maintenanceshift.co.za/api/knowledge";

export const KNOWLEDGE_API_BASE_URL =
  process.env.REACT_APP_KNOWLEDGE_API_URL ||
  (isLocalHost
    ? LOCAL_KNOWLEDGE_API_BASE_URL
    : PRODUCTION_KNOWLEDGE_API_BASE_URL);
